import React from "react";
import { BulkActionsToastData } from "@components/transactions/TransactionsBulkActions/lib/bulkActions";
import { BulkUpdateStatus } from "../lib";
import "./TransactionsUpdateToast.scss";

import { ToastUpdating } from "./ToastUpdating";
import { ToastSuccess } from "./ToastSuccess";

type Props = BulkActionsToastData;

export const TransactionsUpdateToast: React.FC<Props> = ({
    updateDetails,
    ...rest
}) => {
    let content = null;

    switch (updateDetails.status) {
        case BulkUpdateStatus.UPDATING: {
            content = <ToastUpdating updateDetails={updateDetails} {...rest} />;
            break;
        }
        case BulkUpdateStatus.SUCCESS: {
            content = <ToastSuccess updateDetails={updateDetails} {...rest} />;
            break;
        }
    }

    return (
        content && <div className="transactions-update-toast">{content}</div>
    );
};
